var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
// icons
import featuredTag from "@frameworks/shared-library/assets/images/features/Markets/Pms/focused.svg";
import noResultsFound from "@frameworks/shared-library/assets/images/markets/noResultsFound.svg";
import somethingWentWrong from "@frameworks/shared-library/assets/images/markets/somethingWentWrong.svg";
// stylesheets
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/draft.scss";
import "@frameworks/shared-library/stylesheets/components/Offerings/Generic/OfferingsTable.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/draft-modal.scss";
import "@frameworks/salesjourney/stylesheets/components/Features/ClientDetails/ClientOverview/clientOwner.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/common.scss";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import GenericTableShimmer from "@frameworks/shared-library/components/GenericTableShimmer/GenericTableShimmer";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
// shared library
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import DynamicPagination from "@frameworks/shared-library/components/Pagination/Pagination";
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/shared-library/components/ErrorNotification";
import { CLICKED_FROM_DRAFT, UPDATE_TRANS_ID, } from "@redux/feature/Markets/InvestmentManagement/interface";
import useCalculateZoom from "@frameworks/web/utils/useCalculateZoom";
var DraftOrders = function (_a) {
    var _b, _c;
    var title = _a.title, draftLoader = _a.draftLoader, props = __rest(_a, ["title", "draftLoader"]);
    var zoom = useCalculateZoom();
    var _d = useSelector(function (state) { return state.markets.AifPms; }), draftOrderCount = _d.draftOrderCount, errorData = _d.errorData, subCategoryId = _d.subCategoryId;
    var draftOrderList = useSelector(function (state) { return state.markets.AifPms; }).draftOrderList;
    var tableRef = React.useRef(null);
    var getSchemeValue = function (schemeValuesArr, schemeKeysArr, schemeKey) {
        var _a;
        return (_a = schemeValuesArr[schemeKeysArr.indexOf(schemeKey)]) !== null && _a !== void 0 ? _a : "";
    };
    var dispatch = useDispatch();
    var getTagDetails = {
        isNew: {
            text: "New",
            icon: React.createElement("i", { className: "icon edel-icon-glossy" }),
            className: "icon-text-container bg_frosted-aqua txt_ocean-whisper",
        },
        isFocused: {
            text: "Focused",
            icon: React.createElement("i", { className: "icon edel-icon-crown" }),
            className: "icon-text-container bg_candy-pink txt_dark-purple",
        },
    };
    var onSortToggleClick = function (item) {
        var filter = {
            orderByDesc: false,
            orderBy: "",
        };
        filter["orderBy"] = item.key3;
        filter["orderByDesc"] = !props.requestPayload.orderByDesc;
        props.setRequestPayload(__assign(__assign(__assign({}, props.requestPayload), filter), { page: 1 }));
    };
    var handleFetchData = useCallback(function () {
        props.setRequestPayload({
            page: 1,
            pageSize: 10,
            category_code: subCategoryId,
        });
    }, [props.setRequestPayload]);
    var generateTableColumnName = function (name, keyName) {
        return (React.createElement("div", { id: keyName, className: "primary-column-filter-container d-flex align-items-center gap-2 " },
            React.createElement("span", null, name)));
    };
    var generateSchemeName = function (keys, keysForCustomFunction) {
        var tagDetails = {};
        var isFocusedScheme = getSchemeValue(keys, keysForCustomFunction, "isfocused");
        if (isFocusedScheme) {
            tagDetails = getTagDetails.isFocused;
        }
        return (React.createElement("div", { className: "d-flex align-item-center gap-2 position-relative" },
            React.createElement("div", { className: "read-more-tooltip align-items-center flex-1 scheme_name_wrap" },
                React.createElement(GenericSchemeName, { name: keys[1], subText1: keys[4], maxWidth: 100, maxWidthUnit: "%", showTooltip: true, showImage: true, parentClassName: "text-start w-100", tooltipPlacement: "top", tooltipClassName: "scheme-name-tooltip" })),
            isFocusedScheme && (React.createElement("div", { className: "flex-column d-flex align-item-center justify-content-center flex-1 feature-tag-ap" },
                React.createElement("img", { className: "mgl-5", src: featuredTag, alt: "Featured Scheme" })))));
    };
    var fundColumns = [
        {
            columnName: "",
        },
        {
            columnName: "Fund Name",
            key: "",
            key3: "display_name",
            arrows: true,
            columnClassName: "text-end",
            applySorting: true,
            keysForCustomFunction: [
                "trx_id",
                "display_name",
                "isfocused",
                "ucccode",
                "isin_code",
            ],
            tdCustomFunction: function (keys) {
                return generateSchemeName(keys, this.keysForCustomFunction);
            },
        },
        {
            columnName: "Client Name",
            key: "",
            key3: "client_name",
            arrows: true,
            columnClassName: "text-end",
            applySorting: true,
            keysForCustomFunction: ["client_name", "pan"],
            tdCustomFunction: function (keys) {
                return (React.createElement("div", { style: { cursor: "pointer" } },
                    React.createElement("span", { className: "txt-grey-shade1 client-name-wrapper DMSanN_15_400 fw-500 text-start d-block", title: keys[0] }, keys[0] ? keys[0] : "-"),
                    React.createElement("span", { className: "txt_purple-gray RobotoM_14_300  text-start d-block" }, keys[1] ? keys[1] : "-")));
            },
        },
        {
            columnName: generateTableColumnName("Inception Date", "inception_date"),
            key: "inception_date",
            key3: "inception_date",
            arrows: true,
            columnClassName: "text-end",
            applySorting: true,
            tdCustomFunction: function (keys) {
                return (React.createElement("div", { className: "RobotoM_15_400 text-end txt-grey-shade1", style: { cursor: "pointer" } }, keys ? "".concat(moment(keys.toString()).format("DD MMM YYYY")) : "-"));
            },
        },
        {
            columnName: generateTableColumnName("Expected Tenure", "tenure"),
            key: "tenure",
            key3: "tenure",
            key2: "tenure",
            arrows: true,
            columnClassName: "justify-content-end",
            arrowClassName: "justify-content-end",
            applySorting: true,
            tdCustomFunction: function (keys) {
                var value = keys === null || keys === void 0 ? void 0 : keys.split("(");
                return (React.createElement("div", { className: "RobotoM_15_400 text-end txt-grey-shade1", style: { cursor: "pointer" } },
                    keys ? "".concat(value === null || value === void 0 ? void 0 : value[0]) : "-",
                    React.createElement("br", null),
                    (value === null || value === void 0 ? void 0 : value[1]) && (React.createElement("span", { className: "txt-grey-shade1 DMSanN_14_300 fw-300" }, "(+".concat(value === null || value === void 0 ? void 0 : value[1])))));
            },
        },
        {
            columnName: generateTableColumnName("Return exp.", "returns_expectations"),
            key: "returns_expectations",
            key2: "returns_expectations",
            key3: "returns_expectations",
            arrows: true,
            columnClassName: "text-end",
            arrowClassName: "text-right",
            applySorting: true,
            tdCustomFunction: function (keys) {
                return (React.createElement("div", { className: "RobotoM_15_400 text-end txt-grey-shade1", style: { cursor: "pointer" } }, keys ? "".concat(keys.toString()) : "-"));
            },
        },
        {
            columnName: generateTableColumnName("Benchmark", "benchmark"),
            key: "benchmark",
            key2: "benchmark",
            key3: "benchmark",
            arrows: true,
            applySorting: true,
            arrowClassName: "justify-content-end",
            columnClassName: "text-end",
            tdCustomFunction: function (keys) {
                return (React.createElement("div", { className: "RobotoM_15_400 text-end txt-grey-shade1", style: { cursor: "pointer" } }, keys ? "".concat(keys.toString()) : "-"));
            },
        },
        {
            columnName: React.createElement("div", { className: "ms-5" }, "Action"),
            key: "",
            keysForCustomFunction: [
                "trx_id",
                "scheme_name",
                "client_name",
                "ucccode",
                "isFocused",
                "inception_Date",
                "expected_Tenure",
                "return_Expectations",
                "benchmark",
                "scheme_id",
                "min_Investment_Amount",
                "min_Investment_Amount_In_Cr",
                "category",
                "isin_code",
                "issuer_name",
            ],
            tdCustomFunction: function (keysForCustomFunction) {
                return (React.createElement("div", { className: "d-flex align-items-center gap-3 table-row-action-container ms-5" },
                    React.createElement(EdButton, { btnTyp: "tomato-rounded", value: "Place order", slim: true, className: "invest-button text-nowrap DMsanL_15_300", onClick: function (e) {
                            onClickPlaceOrder(e, keysForCustomFunction);
                        }, hoverType: "tomato-rounded-background" })));
            },
        },
    ];
    var onClickPlaceOrder = useCallback(function (e, keysForCustomFunction) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        var element = e.target;
        if (element.tagName === "BUTTON") {
            e.stopPropagation();
        }
        aifPmsDi.draft.draftOrderDetails({
            trx_id: Number((_a = keysForCustomFunction[0]) !== null && _a !== void 0 ? _a : ""),
        });
        dispatch({
            type: UPDATE_TRANS_ID,
            payload: {
                transactionId: Number((_b = keysForCustomFunction[0]) !== null && _b !== void 0 ? _b : ""),
            },
        });
        dispatch({
            type: CLICKED_FROM_DRAFT,
            payload: {
                clickedFromDraft: true,
            },
        });
        var item = {
            trxId: Number((_c = keysForCustomFunction[0]) !== null && _c !== void 0 ? _c : ""),
            display_name: (_d = keysForCustomFunction[1]) !== null && _d !== void 0 ? _d : "",
            isFocused: Boolean((_e = keysForCustomFunction[4]) !== null && _e !== void 0 ? _e : false),
            inception_Date: (_f = keysForCustomFunction[5]) !== null && _f !== void 0 ? _f : "",
            expected_Tenure: Number((_g = keysForCustomFunction[6]) !== null && _g !== void 0 ? _g : ""),
            return_Expectations: (_h = keysForCustomFunction[7]) !== null && _h !== void 0 ? _h : "",
            benchmark: (_j = keysForCustomFunction[8]) !== null && _j !== void 0 ? _j : "",
            schemeId: Number((_k = keysForCustomFunction[9]) !== null && _k !== void 0 ? _k : ""),
            min_Investment_Amount: Number(keysForCustomFunction[9]),
            min_Investment_Amount_In_Cr: String(keysForCustomFunction[10]),
            isin_code: (_l = keysForCustomFunction === null || keysForCustomFunction === void 0 ? void 0 : keysForCustomFunction[13]) !== null && _l !== void 0 ? _l : "",
            amc_product_name: (_m = keysForCustomFunction === null || keysForCustomFunction === void 0 ? void 0 : keysForCustomFunction[14]) !== null && _m !== void 0 ? _m : "",
            category: (_o = keysForCustomFunction === null || keysForCustomFunction === void 0 ? void 0 : keysForCustomFunction[12]) !== null && _o !== void 0 ? _o : "",
        };
        if (props.onClickPlaceOrder) {
            props.onClickPlaceOrder(item);
        }
    }, [dispatch, props]);
    useEffect(function () {
        aifPmsDi.draft.getDraftOrders(props.requestPayload);
    }, [props.requestPayload]);
    var handleCalculateSchemeNameMaxWidth = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        // TODO: This function needs to be refactored more for more proper functionlity
        try {
            if (((_b = (_a = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _a === void 0 ? void 0 : _a.rows) === null || _b === void 0 ? void 0 : _b.length) && ((_c = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _c === void 0 ? void 0 : _c.rows[0].cells)) {
                var totalOccupiedWidthExceptSchemeColumn_1 = (_e = Array.from((_d = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _d === void 0 ? void 0 : _d.rows[0].cells)) === null || _e === void 0 ? void 0 : _e.reduce(function (sum, cell, index) {
                    if (index !== 1) {
                        return sum + cell.offsetWidth;
                    }
                    return sum;
                }, 0);
                var thead = tableRef.current.querySelector("thead");
                var tbody = tableRef.current.querySelector("tbody");
                if (thead) {
                    var secondTh = thead.querySelectorAll("th")[1]; // 0-based index
                    if (secondTh) {
                        secondTh.style.maxWidth = "".concat(((_g = (_f = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _f === void 0 ? void 0 : _f.parentElement) === null || _g === void 0 ? void 0 : _g.clientWidth) -
                            totalOccupiedWidthExceptSchemeColumn_1 -
                            10, "px");
                    }
                }
                if (tbody) {
                    tbody.querySelectorAll("tr").forEach(function (row) {
                        var _a, _b;
                        var secondTd = row.querySelectorAll("td")[1];
                        if (secondTd) {
                            secondTd.style.maxWidth = "".concat(((_b = (_a = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.clientWidth) -
                                totalOccupiedWidthExceptSchemeColumn_1 -
                                10, "px");
                        }
                    });
                }
            }
        }
        catch (_h) { }
    };
    useEffect(function () {
        handleCalculateSchemeNameMaxWidth();
    }, [props.pmsSchemeList]);
    return (React.createElement("div", { style: { zoom: zoom } },
        React.createElement("div", { className: "draft-order-container" },
            React.createElement("p", { className: "title DMSan_28_400 txt-midnight-blue" },
                "Draft Orders (",
                draftOrderCount,
                ")"),
            React.createElement("p", { className: "subtitle DMSan_16_400 txt-grey-shade1" }, "Pick up where you left off and complete your order placement."),
            React.createElement("div", { className: "alert-container" },
                React.createElement("i", { className: "edel-icon-attention-icon lh-22-4", style: { fontSize: 22 } }),
                React.createElement("p", { className: "DMSanN_14_400" }, "Drafted orders stay active for 30 days from the last update and expire automatically afterward.")),
            React.createElement("p", { className: "heading DMSan_26_700 txt-midnight-blue-shade2" }, title)),
        draftLoader && (React.createElement(GenericTableShimmer, { rowCount: 10, columnCount: 8, columnsWidthClass: "table-shimmer-col-fr2-1-1-1-1-1-1-1_2" })),
        props.schemeList.length === 0 && (React.createElement("div", { className: "custom-error-state" },
            React.createElement(Errormsg, { image: noResultsFound, msg: "No Results", customComp: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                    React.createElement("p", { className: "DMSanN_14_400" }, "No schemes found for the above selection")) }))),
        draftOrderList == null ? (React.createElement("div", { className: "top-funds-error custom-error-state" },
            React.createElement(ErrorNotification, { error: errorData === null || errorData === void 0 ? void 0 : errorData.error, isOpen: errorData === null || errorData === void 0 ? void 0 : errorData.isOpen, displayType: ErrorDisplayType.INSECTION, image: somethingWentWrong, customComp: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                    React.createElement("p", { className: "DMSanN_14_400" }, "Try refreshing the page, or try again later."),
                    React.createElement("button", { className: "align-items-center DMSanN_13_500", onClick: handleFetchData }, "Try Again")) }))) : (React.createElement(React.Fragment, null, props.schemeList.length > 0 && (React.createElement(DynamicPagination, { tableRef: tableRef, dataLengthPerPage: 10, data: props.schemeList, Bodycomponent: GenericTable, columns: fundColumns, parentClassName: "top-performing common-compact-table-wrapper ".concat(props.viewAll && "viewAll", " primary-offerings-table-wrapper mx-0 draft aif-pms-oof"), infinityScroll: true, manualNext: props.viewAll
                ? props.totalPages > props.requestPayload.page
                : false, nextFunction: props.viewAll ? props.nextPage : undefined, totalNumberPages: props.viewAll ? props.totalPages : undefined, paginationLoader: draftLoader, initPageNumber: props.viewAll ? props.page : undefined, callbackSorted: onSortToggleClick, selectedSortColumnVal: (_b = props === null || props === void 0 ? void 0 : props.requestPayload) === null || _b === void 0 ? void 0 : _b.orderBy, selectedSortVal: ((_c = props === null || props === void 0 ? void 0 : props.requestPayload) === null || _c === void 0 ? void 0 : _c.orderByDesc) ? "DESC" : "ASC", sortIconUp: "edel-icon-arrow-up-thin", sortIconDown: "edel-icon-arrow-down", viewAll: props.viewAll, isPageFromParent: true, rowOnClick: props.rowOnClick, sortArrowHighlightingColor: "#6374D4" }))))));
};
export default DraftOrders;
